<template>
  <div>
    <b-row>
      <b-col cols="12" md="12" lg="12">
        <b-form>
          <b-form-group :label="$store.state.form.statusKelengkapanPelamar" label-cols-md="3">
            <b-form-select v-model="statusPostLoker" :options="status"></b-form-select>
          </b-form-group>

          <b-form-group label="" label-cols-md="3">
            <b-button variant="primary" v-b-modal.modal-konfirmasi-input-1>
              {{ $store.state.form.simpan }}
            </b-button>
          </b-form-group>

          <!--
          <b-form-group :label="$store.state.form.keterangan" label-cols-md="3">
            <b-form-textarea rows="3"></b-form-textarea>
          </b-form-group>
          -->
        </b-form>
      </b-col>
    </b-row>

    <b-modal
      id="modal-konfirmasi-input-1"
      size="md"
      centered
      :title="$store.state.form.modalTitleKonfirmasi"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <p>{{ $store.state.form.modalBodyKonfirmasi }}</p>

      <template #modal-footer>
        <b-button variant="secondary" @click="batal">
          {{ $store.state.form.tidak }}
        </b-button>
        <b-button variant="primary" :disabled="busy" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
export default {
  name: "detailTabStatus",
  props: ["data", "dataRiwayat"],
  data() {
    return {
      status: [
        { value: 2, text: "Lolos" },
        { value: 0, text: "Tidak Lolos" },
      ],
      statusPostLoker: "",
      busy: false,
      button: "Ya",
    };
  },
  computed: {
    ok() {
      return this.dataRiwayat.length > 0;
    },
  },
  methods: {
    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      if (vm.ok) {
        let datanya = {};
        datanya.id = vm.data.postLokerId;
        datanya.statusPostLoker = vm.statusPostLoker;
        vm.$axios
          .post("postLoker/update", datanya)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = "Ya";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN PELAMAR KE PROSES TAHAPAN",
                showing: true,
              });
              this.$bvModal.hide("modal-detail");
              this.$bvModal.hide("modal-konfirmasi-input-1");
            } else {
              vm.button = "Ya";
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            vm.button = "Ya";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: "TERJADI KESALAHAN PADA SERVER",
              showing: true,
            });
          });
      } else {
        vm.busy = false;
        vm.button = "Ya";
        vm.$emit("alertFromChild", {
          variant: "danger",
          msg: "Harap Lengkapi data riwayat pendidikan untuk melanjutkan!!",
          showing: true,
        });
      }
    },
    batal() {
      this.$bvModal.hide("modal-konfirmasi-input-1");
    },
  },
};
</script>
